<input-icon placement="left">
  <icon-calendar class="text-muted" icon></icon-calendar>
  <input type="text" class="form-control"
         daterangepicker
         [placeholder]="placeholder"
         [disabled]="disabled"
         (selected)="selectedDate($event)"
         (cancelDaterangepicker)="cancelDate()"
         (applyDaterangepicker)="applyDate()"
         (blur)="changeDate($event)" #input>
</input-icon>
